<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">读书不觉已春深</p>
        <p  class="font1" style="padding-top: 1vh;">一寸光阴一寸金</p>

        <p  class="font2" style="padding-top: 5vh;">推荐书籍如下：</p>

        <div class="wrapper">
            <div class="bookTextOne">
                <h3>《完全图解云计算》</h3>
                <div id="qiymet2" @click="openPDF(2)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者：西村泰洋</p>
               
            </div>
            <div class="bookTextTwo">
                <h3>《智慧空间》</h3>
                <div id="qiymet1" @click="openPDF(1)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
                <p style="padding-bottom: 4px;width: 100%;">作者:[美]加布里埃尔·雷内，[美]丹·马普斯</p>  
            </div>
        </div>

        <div class="dialog" v-show="bookShow">        
            <i style="margin-left:95%;color: #090808;" @click="bookShow = false" class="fa fa-close fa-1x"></i>
            <div v-if="this.bookPage==1" style="text-align: justify;width: 100%;">
              <div style="width: 90%;margin: 0 auto;">
                  云计算作为信息通信技术的基础，已经成为不可或缺的存在，人工智能、物联网、大数据及其他各类应用场景，也都需要云计算提供的基础设施的支持才能正常运行，可以说云计算是目前最炙手可热、且广泛应用的互联网技术之一。<br><br>
                  《完全图解云计算》就以图解的形式，对云服务的构建技术、移动技术和安全性三个方面进行了详细解说。<br><br>  
                  通过本书学习，读者可以掌握云是什么，云的作用，云计算的工作原理和云服务如何部署等，从思维方式到技术、运用方法等面面俱到。特别适合作为大中专院校信息通信专业的教学参考书，也适合对云计算感兴趣，想从事相关工作的 IT 技术人员学习。<br><br>  
                  另外，本书还特别适合从事相关工作的商务人士、相关公司的管理和开发人员了解云计算和云服务知识。<br><br>  
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“完全图解云计算”查看！</p>
              </div>
            </div>
            <div v-if="this.bookPage==2" style="text-align: justify;">
              <div style="width: 90%;margin: 0 auto;">
                本书首先回顾了互联网的诞生以及从PC互联到移动互联的发展历程； 然后结合区块链、人工智能、增强现实/虚拟现实、物联网、5G等多种技术的最新成果，揭示在这些先进技术的支撑下，下一代互联网将走向空间化的必然趋势；之后，深入地分析了现有的万维网因其存在的结构性缺陷，将无法承载未来发展，进而详细阐述如何将多种技术融合为一，搭建一个完整的智能空间网络的构思。<br><br>
                本书还就如何将这一全新的网络架构应用于城市管理、建筑/工业设计、仓储物流管理、广告及电子商务提出了具体设想。<br><br>
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典上搜索“智慧空间”查看！</p>
              </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  props: {
    ReportData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      widthWindow: window.innerWidth, 
      widthBlock: window.innerWidth*0.47,
      heightBlock: window.innerHeight*0.257,
      bookPage: 1,
      bookId: 0,
      bookShow: false,
    }
  },
  created() {
    
  },
  methods: {
    openPDF(bookPage) {
      if(bookPage === 1){
        this.bookPage = 1
        this.bookId = 1
      } else {
        this.bookPage = 2
        this.bookId = 2
      }
      this.bookShow = true
    },
  }
}
</script>
  
  <style scoped>
  .body {
    background: url("../../assets/24January/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24January/logo2.png") right  top  no-repeat,
                url("../../assets/24January/bg6.jpg")  no-repeat;
    background-size: 17% 8%,117px 50px,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 80%;
      margin: 0;
      /* text-align: center; */
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #953b5d;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .dialog {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2000;
      /* bottom: 20%; */
      width: 91%;
      height: auto;
      background: #fff;
      border-radius: 7px;
      padding: 7px;
      box-shadow: #eae62ebd 1px;
  }

  .fa {
      color: #fff8e8;
  }


  .wrapper {
      z-index: 1000;
      width: 97%;
      /* height: auto; */
      height: 35vh;
      display: flex;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 10px;;
      border-radius: 17px;
      margin: 0 auto;
      flex-wrap: wrap;
  }

  .bookOne {
      width: 30%;
      height: 20%;
      /* margin-top: 10px; */
  }

  .bookTwo {
      width: 30%;
      height: 20%;
  }

  .bookTextOne {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
  }
  .bookTextTwo {
      margin-left: 11px;
      width: 90%;
      height: 90px;
      color: #000;
    }

    #qiymet2 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
  }

  #qiymet1 {
      float: right;
      margin-right: 20px;
      margin-top: -35px;
      padding: 0px 17px 0px 17px;
      /* width: 51px;
      height: 51px; */
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
      z-index: 1000;
  }

  .zezhao {
      width: 100%;
      height: 100%;
      background: #000000bc;
      z-index: 1920;
      position: absolute;
  }

  button {
      border: none;
      outline: none;
      background-color: rgb(39, 178, 217);
      padding: 10px 20px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      border-radius: 5px;
      transition: all ease 0.1s;
      box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
      margin: 5px;
  }

  button:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
  }

  .donghua{
      animation:flash 3s infinite
    }
    @keyframes flash {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
  }
  </style>